import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { onCLS, onLCP, onINP } from 'web-vitals';
import ReactGA from 'react-ga4';

const container = document.getElementById('root');

// If react-snap has prerendered HTML, hydrate instead of render
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Report Web Vitals to Google Analytics
const sendToGA = ({ name, delta, id }) => {
  const consent = localStorage.getItem('cookie_consent');
  if (consent === 'declined') return;
  ReactGA.event({
    category: 'Web Vitals',
    action: name,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    label: id,
    nonInteraction: true,
  });
};

onCLS(sendToGA);
onLCP(sendToGA);
onINP(sendToGA);
